import { Component, OnInit } from '@angular/core';
import * as logData from './logs.json';
import * as AppPoolSiteData from './AppPoolSites.json';
import * as WindowsServicesData from './WindowsServices.json';
import * as auth from '../auth-config.json';
import { Account } from '../shared/account';
import { MsalBroadcastService, MsalService } from '@azure/msal-angular';
import { AccountInfo, AuthenticationResult, InteractionStatus } from '@azure/msal-browser';
import { filter } from 'rxjs/operators';


@Component({
  selector: 'app-debugtools',
  templateUrl: './debugtools.component.html',
  styleUrls: ['./debugtools.component.css']
})

export class DebugToolsComponent implements OnInit {

  logs = (logData as any).default;
  AppPoolSites = (AppPoolSiteData as any).default;
  WindowsServices = (WindowsServicesData as any).default;
  env = 'QA';
  tool = 'Logs';
  public message: string = "You must login to view this page.";
  loginDisplay = false;
  searchText = '';

  constructor(private authService: MsalService, private msalBroadcastService: MsalBroadcastService) { ; }

  ngOnInit() {
    this.handleSecurity();
  }

  handleSecurity() {

    this.authService.handleRedirectObservable().subscribe({
      next: (result: AuthenticationResult) => {
        if (result) {
          this.authService.instance.setActiveAccount(result.account);
          console.log(result);
        }
        // Sets login display when using redirects
        this.setLoginDisplay();
      },
      error: (error) => console.log(error)
    });

    // Sets login display when using popups
    this.msalBroadcastService.inProgress$
      .pipe(
        filter((status: InteractionStatus) => status === InteractionStatus.None)
      )
      .subscribe(() => {
        this.setLoginDisplay();
      });
  }

  setLoginDisplay() {

    let allowedRoles = [auth.roles.BuildManager];

    let accounts: AccountInfo[] = this.authService.instance.getAllAccounts();
    let account: Account = accounts[0];

    this.loginDisplay = accounts.length > 0;

    if (this.loginDisplay && !allowedRoles.includes(account.idTokenClaims?.roles[0])) {
      this.loginDisplay = false;
      this.message = 'You do not have the correct permissions to view this page.';
    }

  }
}


